var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('weather3',{attrs:{"api-key":"2edb1c47047baf170f473486f84c9f33","city":_vm.$user.hotel.city,"latitude":+_vm.$user.hotel.gps.latitude,"longitude":+_vm.$user.hotel.gps.longitude,"language":_vm.$i18n.locale}})}
var staticRenderFns = []

export { render, staticRenderFns }